/** @format */

import { ChangeDetectorRef, Component, Input, OnChanges, OnInit } from '@angular/core';

import { RatingService } from '@product-reviews/utils';

@Component({
	selector: 'clp-certona-recommendations',
	templateUrl: './certona-recommendations.component.html',
	styleUrl: './certona-recommendations.component.scss',
	standalone: false
})
export class CertonaRecommendationsComponent implements OnInit, OnChanges {
	@Input() productRecommendations: any;

	@Input() displayName: string;

	@Input() filterBy: string;

	@Input() showViewMoreLink: boolean;

	@Input() viewAllText: string;

	@Input() productDisplayLimit: number;

	/**
	 * @description
	 * Modified list of schemas to return to Certona Resonance and display in the template
	 *
	 * @type {any[]}
	 */
	schemas = [];

	/**
	 * @description
	 * Component constructor
	 *
	 * @param changeRef - {ChangeDetectorRef}
	 * @param ratingService - {RatingService}
	 */
	constructor(
		private changeRef: ChangeDetectorRef,
		private ratingService: RatingService
	) {}

	/**
	 * @description
	 * Callback function for Certona Resonance call.  Parses through the Resonance response and builds and updated schema list
	 *
	 * @param response
	 * @returns - {any[]}
	 */
	parseCertonaRecommendations(response?: any) {
		// check if there is a response to process
		if (!response?.resonance?.schemes) return;

		// filter schemes that are relevant, determined by the filterby input
		const filteredSchemas = response.resonance.schemes.filter(
			(schema) => schema.scheme === this.filterBy && schema.display === 'yes'
		);

		// if there are not relevant schemes, short circuit
		if (filteredSchemas.length === 0) return;

		//Iterate through the schemas
		for (const schema of filteredSchemas) {
			// Iterate through the current schema items
			for (const item of schema.items) {
				// parsing price incase comma is there
				item.maxmapprice = item.maxmapprice.replace(',', '');
				item.maxofferprice = item.maxofferprice.replace(',', '');
				item.minmapprice = item.minmapprice.replace(',', '');
				item.minofferprice = item.minofferprice.replace(',', '');
				// Parse the ratings provided by the response
				item['ratings'] = this.ratingService.getStarRatingByAggregateRating(
					parseInt(item.CustomerRating, 10),
					5
				);
			}
		}
		// update the template with the new schema array
		this.schemas = [...filteredSchemas];
		this.changeRef.detectChanges();
	}

	ngOnInit() {
		// Parse the product recommendations
		this.parseCertonaRecommendations(this.productRecommendations);
	}

	ngOnChanges() {
		// Parse the product recommendations
		this.parseCertonaRecommendations(this.productRecommendations);
	}

	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	trackByFn(index: number, _item: any): number {
		return index;
	}
}
